/* SUNKISSED — Sticky product bar, desktop + mobile (loaded, deferred, by sections/sk-pdp-sticky.liquid) */
(function () {
  'use strict';
  var bar = document.querySelector('[data-pdp-sticky]');
  if (!bar) return;
  var form = document.getElementById('product-form');
  var addBtn = form && form.querySelector('[name="add"]');
  var idInput = form && form.querySelector('[name="id"]');
  if (!addBtn || !idInput) return;

  var mq = window.matchMedia('(min-width: 900px)');
  var CFG = {
    posD: bar.getAttribute('data-pos-d') === 'bottom' ? 'bottom' : 'top',
    posM: bar.getAttribute('data-pos-m') === 'top' ? 'top' : 'bottom',
    mobile: bar.getAttribute('data-mobile') !== 'false',
    hideDownD: bar.getAttribute('data-hide-down') !== 'false',
    hideDownM: bar.getAttribute('data-hide-down-m') === 'true'
  };
  var low = parseInt(bar.getAttribute('data-low'), 10) || 0;
  var T = {
    inStock: bar.getAttribute('data-t-instock') || 'In stock',
    low: bar.getAttribute('data-t-low') || 'Only [count] left',
    soldOut: bar.getAttribute('data-t-soldout') || 'Sold out',
    save: bar.getAttribute('data-t-save') || '',
    add: bar.getAttribute('data-t-add') || 'Add to cart'
  };

  var variants = [];
  try { variants = JSON.parse(document.querySelector('[data-ps-variants]').textContent) || []; } catch (e) {}
  var byId = {};
  variants.forEach(function (v) { byId[String(v.id)] = v; });

  var elPrices = [].slice.call(bar.querySelectorAll('[data-ps-price]'));
  var elStock = bar.querySelector('[data-ps-stock]');
  var elImg = bar.querySelector('[data-ps-img]');
  var cta = bar.querySelector('[data-ps-add]');

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  /* Stock: when the "Stock message" section is on, window.skStock gives the same numbers, threshold
     and wording as the buy box (stock minus what is already in the bag), so both never disagree. */
  function stockFor(id, v) {
    var S = window.skStock;
    if (S) {
      var rem = S.remaining(id);
      if (!v.available || rem === 0) return { state: 'out', text: S.texts.out || T.soldOut };
      if (rem !== Infinity && rem <= S.low) return { state: 'low', text: (S.texts.low || T.low).replace('[count]', rem) };
      return { state: 'ok', text: T.inStock };
    }
    var max = (window.skVariantMax || {})[id];
    if (!v.available) return { state: 'out', text: T.soldOut };
    if (low > 0 && typeof max === 'number' && max > 0 && max <= low) return { state: 'low', text: T.low.replace('[count]', max) };
    return { state: 'ok', text: T.inStock };
  }

  /* ---------- Content: follows the selected variant ---------- */
  var lastId = null;
  function render(force) {
    var id = String(idInput.value);
    if (!force && id === lastId) return;
    lastId = id;
    var v = byId[id] || variants[0];
    if (!v) return;

    var html = '';
    if (v.compare) html += '<span class="sk-ps-was"><span class="sr-only">Was </span>' + esc(v.compare) + '</span>';
    html += '<span class="sk-ps-now">' + esc(v.price) + '</span>';
    if (v.compare && v.pct > 0 && T.save) html += '<span class="sk-ps-save">' + esc(T.save.replace('[percent]', v.pct)) + '</span>';
    elPrices.forEach(function (el) {
      el.innerHTML = html;
      el.classList.toggle('is-sale', !!v.compare);
    });

    var st = stockFor(id, v);
    if (elStock) {
      elStock.classList.remove('is-low', 'is-out');
      elStock.textContent = st.text;
      if (st.state === 'low') elStock.classList.add('is-low');
      if (st.state === 'out') elStock.classList.add('is-out');
    }

    if (elImg && v.img) elImg.src = v.img;

    if (cta) {
      cta.disabled = st.state === 'out';
      cta.textContent = st.state === 'out' ? T.soldOut : T.add;
    }
  }

  /* The theme sets the hidden variant input from its own script (no change event fires),
     so re-check after any interaction with the buy box and whenever the main price re-renders. */
  var buybox = document.querySelector('.buybox') || form;
  ['click', 'change'].forEach(function (ev) {
    buybox.addEventListener(ev, function () { setTimeout(render, 80); setTimeout(render, 400); });
  });
  var priceWrap = document.querySelector('[data-price-wrap]');
  if (priceWrap && 'MutationObserver' in window) {
    new MutationObserver(function () { render(); }).observe(priceWrap, { childList: true, subtree: true, characterData: true });
  }
  /* Stock message re-computed (variant / bag changed): re-render with the fresh numbers */
  document.addEventListener('sk:stock', function () { render(true); });

  /* ---------- Position + show / hide ---------- */
  function headerBottom() {
    var h = document.querySelector('.site-header');
    if (!h) return 0;
    return Math.max(0, Math.round(h.getBoundingClientRect().bottom));
  }

  var pos = null;
  function applyPosition() {
    var next = mq.matches ? CFG.posD : CFG.posM;
    if (next !== pos) {
      pos = next;
      bar.classList.toggle('sk-ps--top', pos === 'top');
      bar.classList.toggle('sk-ps--bottom', pos === 'bottom');
    }
    bar.style.top = pos === 'top' ? headerBottom() + 'px' : '';
  }

  var shown = false;
  function setLift() {
    /* Desktop + bottom: move the floating WhatsApp / back-to-top buttons above the bar */
    var lift = (shown && mq.matches && pos === 'bottom') ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--sk-ps-lift', lift + 'px');
  }
  function setShown(on) {
    if (on !== shown) {
      shown = on;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) { bar.removeAttribute('inert'); render(); } else { bar.setAttribute('inert', ''); }
    }
    setLift();
  }

  var lastY = window.pageYOffset;
  var ticking = false;
  function update() {
    ticking = false;
    var y = window.pageYOffset;
    var desktop = mq.matches;
    if (!desktop && !CFG.mobile) { setShown(false); lastY = y; return; }
    applyPosition();
    var hideDown = desktop ? CFG.hideDownD : CFG.hideDownM;
    /* The bar stands in for the main button whenever that button is not on screen:
       - scrolled up behind the header (desktop + mobile)
       - still BELOW the fold (mobile only: on phones the photo gallery pushes the main button
         off the first screen, so without this there would be no buy button visible on arrival) */
    var r = addBtn.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var above = r.bottom < headerBottom();
    var below = !desktop && r.top > vh;
    if (!above && !below) setShown(false);
    else if (!hideDown) setShown(true);
    else if (y < lastY - 4) setShown(true);
    else if (y > lastY + 4) setShown(false);
    if (Math.abs(y - lastY) > 4) lastY = y;
    if (shown && desktop) markActive();
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- Section links ---------- */
  var links = [].slice.call(bar.querySelectorAll('[data-ps-link]'));
  function targetOf(a) {
    var sel = a.getAttribute('data-ps-link');
    try { return sel ? document.querySelector(sel) : null; } catch (e) { return null; }
  }
  function scrollOffset() {
    return headerBottom() + (pos === 'top' ? bar.offsetHeight : 0) + 16;
  }
  links.forEach(function (a) {
    var t = targetOf(a);
    if (!t) { a.hidden = true; return; }
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var y = t.getBoundingClientRect().top + window.pageYOffset - scrollOffset();
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    });
  });
  function markActive() {
    var offset = scrollOffset() + 24;
    var current = null;
    links.forEach(function (a) {
      if (a.hidden || !a.closest('.sk-ps-nav')) return;
      var t = targetOf(a);
      if (t && t.getBoundingClientRect().top - offset <= 0) current = a;
    });
    links.forEach(function (a) { a.classList.toggle('is-active', a === current); });
  }

  /* ---------- CTA: press the real button so stock limits, quantity and the drawer all apply ---------- */
  if (cta) {
    cta.addEventListener('click', function () {
      if (cta.disabled) return;
      addBtn.click();
    });
  }

  render(true);
  update();
})();
